// import loadConfig from "../../Services/apiService";
import "./style.css";
import { useEffect, useState } from "react";
import $ from "jquery";
import loadConfig from "../../Services/Api/ApiServices";
// props who receives it

// * maxWidth string value

// * maxHeight string value

// * component html tage value

// * title popup

// * onClose function value

// * isPopupOpen boolean value

const PopupAHSF = (props) => {
  const [dataJsonObject, SetDataJsonObject] = useState();

  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);
  return (
    <>
      {props.isPopupOpenStatus && (
        <div className="popup-overlay">
          <div
            className="popup-content"
            style={{ "max-width": props.maxWidth }}
          >
            <div className="popup-header" id={props.id}>
              <button
                id={props.idButton}
                className="close-btn"
                onClick={props.isPopupOpenFunction}
              >
                <span className="nameIconeClosw">
                  <i className="bi bi-x-square-fill"></i>
                </span>
              </button>
              <h3 className="popup-title">{props.title}</h3>
            </div>
            {props.forValidate ? (
              <>
                <div
                  className="popup-body"
                  style={{ "max-height": props.maxHeight }}
                >
                  {props.componentBody
                    ? props.componentBody.map((elem, i) => {
                        if (typeof elem == "string") {
                          return (
                            <p className="popupText">
                              {dataJsonObject && dataJsonObject[elem]?.nameAR}
                            </p>
                          );
                        } else {
                          return <p className="popupText">{elem?.message}</p>;
                        }
                      })
                    : ""}
                  {/* {props.componentBody} */}
                </div>
                <div className="validatePopUpBtn">
                  <button className="" onClick={props.isPopupOpenFunction}>
                    خروج
                  </button>
                </div>
              </>
            ) : props.forValidateAllPages ? (
              <>
                <div
                  className="popup-body"
                  style={{ "max-height": props.maxHeight }}
                >
                  {Object.keys(props.componentBody).map((key) => (
                    <div key={key}>
                      <a
                        className="ahref"
                        href={`/SRFund${key.split(",").pop().trim()}`}
                      >
                        {" "}
                        {key.split(",")[0].trim()} :
                      </a>
                      {/* <h3 style={{ color: "red", marginTop: "1%" }}>
                        {key.split(",")[0].trim()} :
                      </h3> */}
                      <ul className="ulbody">
                        {props.componentBody[key].map((item, index) => (
                          <p className="popupText">
                            {key ==
                              "صفحة المرفقات والتعهد , /AttachmentsAndPledge#" ||
                              key ==
                                "خطة العمل والموازنة التقديرية , /WorkPlanEstimatedBudget"||
                                key ==
                                  "تضارب المصالح واخلاقيات البحث , /ConflictOfInterestAndResearchEthics"
                              ? item.code
                              : dataJsonObject &&
                                dataJsonObject[item.code]?.nameAR}
                          </p>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
                <div className="validatePopUpBtn">
                  <button className="" onClick={props.isPopupOpenFunction}>
                    خروج
                  </button>
                </div>
              </>
            ) : props.valedatManager ? (
              <>
                <div
                  className="popup-body"
                  style={{ "max-height": props.maxHeight }}
                >
                  {props.componentBody
                    ? props.componentBody.map((elem, i) => {
                        return (
                          <p className="popupText">
                            {elem.fieldName}: <span>{elem.message}</span>
                          </p>
                        );
                      })
                    : ""}
                </div>
                <div className="validatePopUpBtn">
                  <button className="" onClick={props.isPopupOpenFunction}>
                    خروج
                  </button>
                </div>
              </>
            ) : (
              <div
                className="popup-body"
                style={{ "max-height": props.maxHeight }}
              >
                {props.componentBody}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PopupAHSF;
